const inputsNames = {
  name: 'name',
  phoneNumber: 'phoneNumber',
  email: 'email',
};

export {
  inputsNames,
};
